import qs from 'qs';

import { API_HOST, API_EXPORT, MAIN_HOST, BACKEND_API_HOST, BACKEND_API_TRACKING_HOST } from './host';
import { getAuthToken } from '../utils/safeStorage';

export const requestTracking = (action, data) => {
  return fetch(BACKEND_API_TRACKING_HOST + action, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      // 'Cache-Control': 'no-cache'
    },
    body: qs.stringify(data),
  })
    .catch((error) => {
      console.error(error);
    })
    .then((response) => response?.json());
};

export const requestData = (action, data) => {
  return fetch(BACKEND_API_HOST + action, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      // 'Cache-Control': 'no-cache'
    },
    body: qs.stringify(data),
  })
    .catch((error) => {
      console.error(error);
    })
    .then((response) => response?.json());
};

export const requestAuth = (action, api_token) => {
  return fetch(BACKEND_API_HOST + action, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      Authorization: 'bearer ' + api_token,
    },
    body: qs.stringify({ api_token: api_token }),
  })
    .catch((error) => {
      console.error(error);
    })
    .then((response) => response?.json());
};

export const requestChat = async (API_HOST, action, data, method = 'POST') => {
  try {
    const response = await fetch(`${API_HOST}${action}`, {
      method,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const text = await response.text();

    // Coba parse JSON, kalau gagal, log error dan lempar
    try {
      const json = text ? JSON.parse(text) : {};
      json.statusCode = response.status;
      return json;
    } catch (parseErr) {
      console.error('❌ Failed to parse JSON response:', text);
      throw new Error('Invalid JSON response from server.');
    }
  } catch (err) {
    console.error('❌ Request failed:', err);
    throw err;
  }
};

export const requestDataWithFile = (action, data) => {
  const token = getAuthToken();
  if (token && data instanceof FormData) {
    data.append('token', token);
  }
  return fetch(BACKEND_API_HOST + action, {
    method: 'POST',
    headers: {},
    body: data,
  })
    .catch((error) => {
      console.error(error);
    })
    .then((response) => response?.json());
};
